import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './menu-item.module.scss'

function MenuItem({ href, children, items, active, deepActiveName, level }) {
  return (
    <div className={classNames(styles.root, styles[`root${level}`])}>
      <a
        href={href}
        className={classNames(
          styles.link,
          styles[`link${level}`],
          active ? styles.linkActive : ``
        )}
      >
        {children}
      </a>
      {items && (
        <div className={classNames(styles.items, styles[`items${level}`])}>
          {items.map(({ name, title, path, children: itemChildren }) => (
            <MenuItem
              key={name}
              href={path}
              items={itemChildren}
              active={name === deepActiveName}
              level={level + 1}
            >
              {title}
            </MenuItem>
          ))}
        </div>
      )}
    </div>
  )
}

MenuItem.propTypes = {
  children: PropTypes.string,
  href: PropTypes.string,
  items: PropTypes.array,
  active: PropTypes.bool,
  deepActiveName: PropTypes.string,
  level: PropTypes.number,
}

export default MenuItem
